export const bookingFieldCopy = {
  en: { date: "Preferred date", participants: "Participants", message: "Message", name: "Name" },
  it: { date: "Data desiderata", participants: "Partecipanti", message: "Messaggio", name: "Nome" },
  de: { date: "Wunschdatum", participants: "Teilnehmer", message: "Nachricht", name: "Name" },
  fr: { date: "Date souhaitée", participants: "Participants", message: "Message", name: "Nom" },
  es: { date: "Fecha deseada", participants: "Participantes", message: "Mensaje", name: "Nombre" },
  pt: { date: "Data pretendida", participants: "Participantes", message: "Mensagem", name: "Nome" },
};

export function buildTourWhatsAppMessage(baseMessage: string, details: {
  name: string; date: string; participants: string; message: string;
}, language: string) {
  const copy = bookingFieldCopy[language as keyof typeof bookingFieldCopy] ?? bookingFieldCopy.en;
  return `${baseMessage}\n\n${copy.name}: ${details.name}\n${copy.date}: ${details.date}\n${copy.participants}: ${details.participants}\n${copy.message}: ${details.message.trim() || baseMessage}`;
}